<template>
  <section :class="['box-section', { 'has-title': title }]">
    <div class="box-section-header" v-if="title">
      <h2 class="box-section-title headline-m">{{ title }}</h2>
    </div>

    <div class="box-section-content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BaseBoxSection',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.box-section {
  border-radius: 8px;
  overflow: hidden;

  &-header {
    background-color: #000;
    padding: 12px 16px;
  }

  &-title {
    color: #fff;
    margin: 0;
  }

  &-content {
    display: flex;
    flex-direction: column;
    gap: 26px;
  }

  &.has-title {
    .box-section-content {
      background-color: #fff;
      padding: 16px;
    }
  }
}
</style>
